export default "__VITE_ASSET__cf00e238__"